import { appStorageService } from '@saucelabs/sl-util-axios';

export const fetchAppGroups = ({
  entriesPerPage = 25,
  osFilters = ['ios', 'android'],
  paginationPage = 1,
  searchQuery,
} = {}) => (
  appStorageService.get('/v1/storage/groups', {
    params: {
      page: paginationPage,
      per_page: entriesPerPage,
      q: searchQuery, // eslint-disable-line id-length
      kind: osFilters?.length ? osFilters : ['ios', 'android'], // Empty filters would return all apps, including the ones of kind "other"
    },
  })
);
